// generated from 14 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const ecommerceSourceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("ecommerce_source_filter"),
  // Constants::Comparisons.boolean_blank_comparisons: is / is not / is not blank / is blank.
  comparison_key: z.enum([
    "1", // 13 (92.86%)
    "2",
    "11", // 1 (7.14%)
    "12",
  ]),
  display_name: z.string(),
  // Only present when the filters_include_raw_values feature flipper is on (FilterJsonFormatter#filter_as_json).
  raw_value: z.string().optional(),
  value: z.string(),
  varies_by_app_group: z.literal(false),
});
